module.exports = __webpack_public_path__ + "img/title.caebbb1f.png";